import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import FormService from '../../../core/services/FormService';

const validateColorPalette = (colorPalette) =>
  ![50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950].every((level) =>
    Object.keys(colorPalette).includes(level.toString())
  ) && 'All colors levels are required (50 to 950)';

class WhitelabelConfigColorPaletteService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      whitelabelConfigId: null,
    });
    this.form.validations = {
      primaryColorPalette: [isRequired, validateColorPalette],
      accentColorPalette: [isRequired, validateColorPalette],
    };
  }

  init = action((whitelabelConfigId) => {
    this.whitelabelConfigId = whitelabelConfigId;
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: `/whitelabel-configs/${this.whitelabelConfigId}`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.form.setInitialValues({
            primaryColorPalette: this.fetch.data.primaryColorPalette,
            secondaryColorPalette: this.fetch.data.secondaryColorPalette,
            accentColorPalette: this.fetch.data.accentColorPalette,
          });
        } else {
          this.form.setInitialValues({
            primaryColorPalette: undefined,
            accentColorPalette: undefined,
          });
        }
      });
  });

  handleSubmit = action(() => {
    this.submit
      .fetch({
        url: `/whitelabel-configs/${this.whitelabelConfigId}/color-palette`,
        method: 'patch',
        body: this.form.getValues(),
      })
      .then(() => {
        if (this.submit.data) {
          this.load();
          NotificationService.addNotification('Color palette updated', 'success');
        } else {
          NotificationService.addNotification('Error to update color palette', 'error');
        }
      });
  });
}

export default WhitelabelConfigColorPaletteService;
